import { TypeOrNull } from '@network/models/common.model'
import { IFavorite } from '@network/models/favorite.model'
import { IBaseGetParams, IMeta } from '@network/models/global.model'
import { ILoadingIds } from '@network/models/loading.model'
import { IPunchCard } from '@network/models/punch-card.model'
import { IRoster } from '@network/models/roster.model'
import { IUser, USER_STATUS } from '@network/models/user.model'

export interface IMyUpshiftersReducer {
  data: IMyUpshifter[]
  meta: IMeta
  isFetching: boolean
  deleteFromRosterLoadingIds: ILoadingIds
  sortingState: IMyUpshiftersSortingState
}

export interface IMyUpshifter {
  id: number
  avatar_thumb_url: string
  avatar_url: string
  favored_by?: IUser
  finished_punch_cards_sum_hours_total?: number
  first_name: string
  full_name: string
  last_completed_punch_card?: IPunchCard
  last_name: string
  status?: USER_STATUS
  worked_data?: { data: IWorkedData[] }
  rosters?: {
    data: IRoster[]
  }
  favored_by_business?: TypeOrNull<IFavorite>
  blocked_properties_count: TypeOrNull<number>
  total_properties_count: TypeOrNull<number>
  finished_punch_cards_thirty_trailing_days_sum_hours_total?: number
}

export interface IWorkedData {
  user_id: number
  gig_type_name: string
  hours_worked: number
}

export interface IGetMyUpshiftersBaseParams extends IBaseGetParams {
  roster_ids?: number[]
  business_id?: number
  worked_for_property_ids?: number[]
  favored_by_ids?: number[]
  worked_gig_type_ids?: number[]
  favored?: boolean
  blocked?: boolean
  order_by?: string
  order_by_direction?: SORTING_DIRECTION
}

export interface IGetMyUpshiftersIncludeParams {
  include?:
    | {
        last_completed_punch_card?: {
          business_id?: number
        }
        finished_punch_cards_sum_hours_total?: {
          business_id?: number
        }
        favored_by?: {
          business_id?: number
        }
        rosters?: {
          business_id?: number
        }
        favored_by_business?: {
          business_id?: number
        }
        worked_data?: {
          business_id?: number
        }
        finished_punch_cards_thirty_trailing_days_sum_hours_total?: string
      }
    | (
        | 'last_completed_punch_card'
        | 'finished_punch_cards_sum_hours_total'
        | 'favored_by'
        | 'rosters'
        | 'favored_by_business'
        | 'worked_data'
        | 'finished_punch_cards_thirty_trailing_days_sum_hours_total'
      )[]
}

export type TGetMyUpshiftersParams = IGetMyUpshiftersBaseParams &
  IGetMyUpshiftersIncludeParams

export interface IGetMyUpshiftersCountParams {
  business_id: number
}

export interface IMyUpshiftersCount {
  count: number
}

export interface IAddToMultipleRostersParams {
  roster_ids: number[]
  business_id: number
}

export enum SORTING_DIRECTION {
  ASC = 'asc',
  DESC = 'desc',
}

export interface IMyUpshiftersSortingState {
  columnId: TypeOrNull<string>
  direction: TypeOrNull<SORTING_DIRECTION>
}
